module.exports = __webpack_public_path__ + "static/media/explore3.9ab21ca7.jpg";